// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedDryEyeReport_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M21 8V24H3L3.00006 0H13V2L5.00006 2L5.00006 22L19 22L19 8H21Z" class="svg-bg"/>
  <path d="M15 0 21 6H15V0ZM7 4H13V6H7V4ZM13.5 12C13.5 12.8284 12.8284 13.5 12 13.5 11.1716 13.5 10.5 12.8284 10.5 12 10.5 11.1716 11.1716 10.5 12 10.5 12.8284 10.5 13.5 11.1716 13.5 12Z" class="svg-bg"/>
  <path d="M12.6206 13.962C12.4192 13.9869 12.212 14 11.9999 14C10.2089 14 8.77254 13.0652 8.16086 12C8.77254 10.9348 10.2089 10 11.9999 10C13.7855 10 15.2187 10.9291 15.8335 11.9903L16.043 12.1945C16.0563 12.21 16.0748 12.2317 16.0982 12.2593C16.1448 12.3144 16.2106 12.3933 16.2912 12.4924C16.4521 12.6904 16.6737 12.9712 16.9203 13.3079C16.9946 13.4093 17.0714 13.5161 17.1496 13.6274C17.5374 13.1364 17.8298 12.5878 18 12C17.3339 9.6997 14.7957 8 11.9999 8C9.20418 8 6.66606 9.6997 6 12C6.62533 14.1596 8.90074 15.7899 11.4903 15.9812C11.5361 15.875 11.5833 15.7714 11.6311 15.6708C11.9217 15.0599 12.2798 14.47 12.6206 13.962Z" class="svg-bg"/>
  <path d="M14.1782 15.1071C13.6265 15.9293 13 17.0531 13 17.9165C13 19.0584 13.893 20 15 20C16.107 20 17 19.0684 17 17.9165C17 17.0531 16.3735 15.9293 15.8218 15.1071C15.7541 15.0063 15.6876 14.91 15.6235 14.8193C15.2763 14.328 15 14 15 14C15 14 14.7237 14.328 14.3765 14.8193C14.3124 14.91 14.2459 15.0063 14.1782 15.1071Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedDryEyeReport is a generated icon component.
 */
let IconMedDryEyeReport = IconMedDryEyeReport_1 = class IconMedDryEyeReport extends IconBaseElement {
    render() {
        return html `${IconMedDryEyeReport_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedDryEyeReport.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedDryEyeReport = IconMedDryEyeReport_1 = __decorate([
    customElement('zui-icon-med-dry-eye-report')
], IconMedDryEyeReport);
export { IconMedDryEyeReport };
